import React from 'react';
import { observer } from 'mobx-react-lite';

import { Tag, TagTarget } from '../../../app/entities/tag';
import { TagCollection } from './tag-collection';

import styles from './tag-list.module.scss';
type TagListProps = {
  tags: Tag[];
};

export const TagList: React.FC<TagListProps> = observer(({ tags }) => {
  const groupedTags: Record<TagTarget, Tag[]> = Tag.groupAndSortTags(tags);

  return (
    <>
      <div className={styles['list-header']}>
        <div>Name</div>

        <div className={styles['right']}>
          <div>Usage</div>
          <div />
        </div>
      </div>

      <div className={styles['container']}>
        {Object.entries(groupedTags).map(([target, tags]) => (
          <TagCollection
            key={target}
            target={target as TagTarget}
            tags={tags}
            defaultValue={{ target }}
          />
        ))}
      </div>
    </>
  );
});
